import { Field } from '@headlessui/react';
import { forwardRef } from 'react';
import { GlobalError } from 'react-hook-form';
import { textFieldErrorMessages } from '@/constants/text-field-error-messages';
import { Description } from './description';
import { Label } from './label';
import { Select, SelectProps } from './select';

export type SelectFieldProps<
  TOptionValue extends string | number = string | number,
> = SelectProps<TOptionValue> & {
  description?: string;
  error?: GlobalError;
  label: string;
};

export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  ({ description, error, label, ...props }, ref) => (
    <Field className="w-full max-w-md">
      <div className="mb-2 flex flex-col">
        <Label>{label}</Label>
        {description && <Description>{description}</Description>}
      </div>
      <Select error={error} {...props} ref={ref} />
      {error && typeof error.type === 'string' && (
        <span
          className="mt-2 block text-sm font-normal text-red-600"
          role="alert"
        >
          {textFieldErrorMessages[error.type] ?? textFieldErrorMessages.default}
        </span>
      )}
    </Field>
  ),
);
